import cn from 'classnames'
import BaseModal, {
  BaseModalProps,
} from 'ext-ui/components/BaseModal/BaseModal'
import React, { ReactElement } from 'react'
import ReviewEnrollCard, {
  ReviewEnrollCardProps,
} from 'src/app/ReviewEnrollCard/ReviewEnrollCard'
import { useTranslate } from 'src/localization/Trns'

import style from './ConnectPhysicalCardModal.style'

type ConnectPhysicalCardModalProps = BaseModalProps & {
  reviewEnrollCardProps: ReviewEnrollCardProps
  /**
   * When false, overlay click and Escape key don't close the modal.
   * Mirrors the ChargebeeCheckoutModal dismissible pattern — used on
   * the pricing-page post-subscribe flow where backing out of the card
   * registration would leave the user in a broken state.
   */
  dismissible?: boolean
}

export default function ConnectPhysicalCardModal(
  props: ConnectPhysicalCardModalProps,
): ReactElement {
  const translate = useTranslate()
  const {
    className = '',
    variant = 'popup',
    isOpen,
    onClose,
    reviewEnrollCardProps,
    dismissible = true,
  } = props

  return (
    <BaseModal
      className={cn('ConnectPhysicalCardModal', className)}
      variant={variant}
      isOpen={isOpen}
      onClose={dismissible ? onClose : (): void => undefined}
      showCloseButton={dismissible}
      shouldCloseOnEsc={dismissible}
      shouldCloseOnOverlayClick={dismissible}
      css={style}
      aria-label={translate('Connect Physical Card Modal')}
    >
      <ReviewEnrollCard {...reviewEnrollCardProps} />
    </BaseModal>
  )
}
